import setRoamingPrimaryTimezoneLabel from '../data/mutators/setRoamingPrimaryTimezoneLabel';
import { getDefaultPrimaryTimezoneLabel } from 'owa-calendar-cloud-settings';

export default function loadRoamingPrimaryTimezoneLabel() {
    const roamingPrimaryTimezoneLabel: string = getDefaultPrimaryTimezoneLabel();
    setRoamingPrimaryTimezoneLabel(roamingPrimaryTimezoneLabel);
}
